module.exports = __webpack_public_path__ + "img/next22.3e102816.jpg";